import { useEffect, useState } from "react";
import { fetchWithAuth } from "../../api/fetchWithAuth";
import { usePlatformOrgContext } from "../../stores/usePlatformOrgContext";

export default function PlatformOrgPicker() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  const { activeOrgId, activeOrgName, setActiveOrg, clearActiveOrg } =
    usePlatformOrgContext();

  useEffect(() => {
    async function load() {
      const res = await fetchWithAuth("/api/v1/platform/orgs");
      const data = await res.json();
      setOrgs(data.orgs || []);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) {
    return (
      <div className="text-xs text-gray-400">
        Loading orgs…
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs">
      <span className="text-gray-400">Viewing as</span>

      <select
        className="bg-bg-soft border border-bg-border rounded px-2 py-1 text-gray-200"
        value={activeOrgId || ""}
        onChange={(e) => {
          const id = e.target.value;
          const org = orgs.find(o => o.id === id);
          if (org) setActiveOrg(org);
          else clearActiveOrg();
        }}
      >
        <option value="">— Select org —</option>
        {orgs.map(o => (
          <option key={o.id} value={o.id}>
            {o.name}
          </option>
        ))}
      </select>

      {activeOrgName && (
        <span className="text-orange-300">
          ({activeOrgName})
        </span>
      )}
    </div>
  );
}